import { metricType } from "../../generic/PageUI/constants"
import { MetricUId } from "../Metrics/constants"
import getChartConfigTemplate from "./Templates/BarOrColumnChart/utils"

export const metricColorMap = {
  [MetricUId.GOOD_MEETING_RATING_REASONS]: "#198754",
  [MetricUId.BAD_MEETING_RATING_REASONS]: "#E16335"
}

export const getMeetingRatingReasonsChartHeight = (dataCount) => {
  // TODO_GC_REPORTING_LOW: Find a way to render whole chart and use parent element to scroll instead of setting variable height
  // In case of Zero state, 300 will be the default height. Else chart height will be calculated based on data size
  return Math.max(dataCount * 60, 300);
}

export const getMeetingRatingReasonsChartConfig = (data, options={}) => {
  return getChartConfigTemplate({
    data: data,
    height: options.height,
    color: options.color,
    barPointWidth: 24,
    shouldEnableLinks: options.shouldEnableLinks,
    shouldEnableLabelLinks: true,
    showYaxisLabels: false,
    xaxisLabelsMetricType: metricType.SUBMETRIC,
    showPreviousPeriodDataLabels: false,
    exportFileName: options.exportFileName
  })
}
